import { FeeAccounting } from 'further-types/investment';

type Props = {
  isChargedToInvestorDisable?: boolean;
  isAccruedDisable?: boolean;
};

export const getFeeAccountingOptions = ({
  isChargedToInvestorDisable,
  isAccruedDisable,
}: Props = {}) => {
  return [
    {
      label: 'Charged to investor',
      value: FeeAccounting.ChargedToInvestor,
      disabled: isChargedToInvestorDisable,
    },
    {
      label: 'Accrued',
      value: FeeAccounting.Accrued,
      disabled: isAccruedDisable,
    },
  ];
};
